export default __webpack_public_path__ + "static/media/Backback.da82dcff.svg";